export const Bus = new EventTarget();

export const Events = {
    CONTENT_LOAD: 'content:load',
    WEATHER_LOAD: 'weather:load',
    WEATHER_SUCCESS: 'weather:success'
};